
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useNotificationStore } from 'SharedDir/stores/notification.store';

export default defineComponent({
  emits: ['update'],
  setup(props, { emit }) {
    const notificationStore = useNotificationStore();

    const countNotifications = computed(() => notificationStore.getCountUnreadNotifications);
    const haveNotifications = computed(() => countNotifications.value > 0);
    const changeVisible = () => {
      emit('update');
    };

    return {
      countNotifications,
      haveNotifications,
      changeVisible,
    };
  },
});
